import { render } from "./pageTopic.vue?vue&type=template&id=37f1d1d9&scoped=true"
import script from "./pageTopic.vue?vue&type=script&lang=js"
export * from "./pageTopic.vue?vue&type=script&lang=js"

import "./pageTopic.vue?vue&type=style&index=0&id=37f1d1d9&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f1d1d9"]])

export default __exports__